<div class="container">
  <div class="accordion accordion-flush mt-5" id="accordionFlushExample">
    <div class="accordion-item">
      <h2 class="accordion-header" id="flush-headingOne">
        <button
          class="accordion-button collapsed"
          type="button"
          id="analytics_cta"
          data-bs-toggle="collapse"
          data-bs-target="#flush-collapseOne"
          aria-expanded="false"
          aria-controls="flush-collapseOne"
          aria-label="ghj"
          id="acco-header"
        >
          {{page_content?.label}}
        </button>
      </h2>
      <div
        id="flush-collapseOne"
        class="accordion-collapse collapse"
        aria-labelledby="flush-headingOne"
        data-bs-parent="#accordionFlushExample"
      >
        <div class="accordion-body" [innerHTML]="$safeNavigationMigration(page_content?.longText)">
         
        </div>
      </div>
    </div>
  </div>
</div>
